<style  scoped>


ul {
    list-style: none;
}
.menu__item {
    position: relative;
    padding-right: 3rem;
}
.menu__link {
    text-transform: uppercase;
}
.menu__icon {
    margin: 0 !important;
}
.dropdown-menu {
    text-align: left;
    font-size: 0.9rem;
    position: absolute;
    min-width: 130px;
    padding: 0px;
    margin: 0px;
    display: none;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
}

.is-header-fixed  .dropdown-menu {
    text-align: left;
    font-size: 0.9rem;
    position: absolute;
    min-width: 130px;
    padding: 0px;
    margin: 0px;
    display: none;
    background-color:#AAAAAA;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
}

.dropdown-menu__item:first-child .dropdown-menu__link {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}
.dropdown-menu__item:last-child .dropdown-menu__link {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}
.dropdown-menu__link {
    display: block;
    padding: 0.5rem;
   /*background-color:rgba(255, 255, 255, 0.9);*/
}
.dropdown-menu__linkHard {
    display: block;
    padding: 0.5rem;

    color:rgba(0,0,0,1);
}
.dropdown-menu__linkHard:hover {

    color:rgba(28,43,84,0.8);
}
.dropdown-menu__link:hover {

    background-color:rgb(243, 243, 243,0.2);
}

.is-header-fixed .dropdown-menu__link:hover {

    background-color:rgb(225, 225, 225, 0.2);
}

.open .dropdown-menu {
	display: block;
}
</style>

<template>  

<header class="c-header u-fixed u-pos-tl u-marg-t-privinvest-menu-lg u-fit-w     u-align-center   u-pad-x-w1of5  u-marg-t-md@sm u-align-left@sm js-header" style="z-index:10;height:95px;">
     <div class="c-header__container">
        <router-link to="/" class="c-header__logo t-link u-absolute u-pos-l u-inline-block u-relative@sm"><img src="../../assets/medias/images/SalamehGourmehStrore-Logo.png" v-if="'grocery' !== $route.name"><img src="../../assets/medias/images/SalamehGourmehStrore-Logo-black.png"  v-if="'grocery' === $route.name"></router-link>
        <ul class="c-header__container__list o-list--inline u-inline-block u-valign-bottom u-margin-xmmenu u-marg-b-xs u-hide@lg ">
            <!--<li class="c-header__item o-list__item" v-for="(item, index)  in content.nav.links" :class="{'u-marg-r-mds':((content.nav.links.length - 1)!=(index)),'c-header__item--dropdown':item.dropdown===true,'open' :dropDowns1[item.id].open==true}" @click="toggle(item.id)"  >-->
              <li class="c-header__item o-list__item" v-for="(item, index)  in content.nav.links" :class="{'u-marg-r-mds':((content.nav.links.length - 1)!=(index)),'c-header__item--dropdown':item.dropdown===true,'open' :dropDowns1[item.id].open==true}" @mouseover="toggle(item.id)"  @mouseout="toggle(item.id)" >
                  <router-link :to="'/'+$route.params.lang+'/'+item.href"  v-if="item.dropdown===false"  class="c-header__item__link t-link t-text--base-menu-bold t-text-ls--lg u-uppercase" :class="{'u-color--blackcontracting ':'grocery' !== $route.name,'u-color--brand-dark':'grocery' === $route.name}" active-class="is-active" exact>{{item.label}}</router-link>
                  <a  v-if="item.dropdown===true"  class="c-header__item__link t-link t-text--base-menu-bold t-text-ls--lg u-uppercase" :class="{'u-color--blackcontracting ':'grocery' !== $route.name,'u-color--brand-dark':'grocery' === $route.name}" active-class="is-active" exact>{{item.label}}</a>
                  <ul class="dropdown-menu" v-if="item.dropdown===true" :style="{width:item.dropdownWidth}">
                      <li   v-for="(dropitem, dropindex)  in item.dropdownLinks">
                            <router-link :to="'/'+$route.params.lang+'/'+dropitem.href"  class="c-header__item__link_BackWhite t-link t-text--base-menu-bold t-text-ls--lg u-uppercase" :class="{'u-color--blackcontracting dropdown-menu__link ':'grocery' !== $route.name,'dropdown-menu__linkHard':'grocery' === $route.name}"  active-class="is-active" exact>{{dropitem.label}}</router-link>
                      </li>
                    </ul>
            </li>
        </ul>
    </div>
</header>

</template>

<script>

export default {
    name: "app-header",
    props: {
        debug: {
            type: Boolean,
            default: !1
        },
        content: {
            type: Object,
            default: function() {}
        },
        color: {
            type: String,
            default: ""
        }
    },
    data: function()
    {
        return {
          colorinside:"clear",
         dropDowns1:
          {
                  thehome:{ open: false} ,
                  thegroup: { open: false} ,
                  subsidiaries: { open: false},
                  prodcuts: { open: false} ,
                  sistercompany: { open: false} ,
                  Innovations: { open: false} ,
                  News: { open: false} ,
                  RepairandRefit: { open: false} ,
                  Contact: { open: false}
        }
          //dropDowns: []
    }

    },
    mounted: function()
    {
       //console.log("this.$route.name:"+this.color);
       //"news" === this.$route.name?this.colorinside="dark":this.colorinside="clear"
       //this.dropDowns=this.dropDowns1
    },
    created: function()
    {
      this.dropDowns = this.computedDropdowns
      console.log(this.dropDowns);
    },
    computed:
    {

          computedDropdowns: function()
          {
              var t = [];
              var n = this.content.nav.links.length;
              //console.log(n);
              for (var e = 0;  e < n; e ++)
              {
                  var r = this.content.nav.links[e];
                  t[r.id]=[];
                //  console.log(r.id);
                  t[r.id]["dropdown"]= r.dropdown
                  t[r.id]["id"]=r.id;
                  t[r.id]["open"]=false;
                  t[r.id]["links"]=r.dropdownLinks;
                  //console.log(t[r.id]);
                }
                return t ;
          }
    },
    methods:
    {
    toggle(dropdownName)
    {
       console.log(this.dropDowns[dropdownName].open);
       this.dropDowns1[dropdownName]['open'] = !this.dropDowns1[dropdownName].open;
       console.log(this.dropDowns[dropdownName].open);
    },
    close()
    {
      for (dd in this.dropDowns)
      {
        this.dropDowns[dd].open = false;
      }
    }
  }

}

</script>
